module.exports = __webpack_public_path__ + "94e192f52336f09fa6c66bfe982cb4c6.svg";